export default function getTexts(lang = 'it', comBrand = '') {
  const base = {
    it: {
      title: `Fattibilità - ${comBrand}`,
      marca: 'Marca',
      modello: 'Modello',
      codiceMotore: 'Codice motore',
      cerca: 'Cerca',
      chiedi: 'Chiedi',
      nessuno: 'Nessuno',
      selectBrandFirst: 'Seleziona una marca se vuoi i suggerimenti',
      selectBrandAndModelFirst: 'Seleziona prima marca e modello se vuoi i suggerimenti',
      documents: 'Documenti',
      packages: 'Pacchetti e Calibrazioni',
      userNotes: 'Note per l\'utente',
      headers: {
        cylinders: 'Cilindri',
        displacement: 'Cilindrata (cc)',
        power: 'Potenza (kW)',
        euro: 'Euro',
        petrolEcu: 'ECU Benzina'
      },
      classicSearchTitle: 'Ricerca Classica',
      aiSearchTitle: 'Ricerca AI',
      aiSearchLabel: 'Chiedi in linguaggio naturale (es. "ho una alfa tonale, mostra collegamenti elettrici")',
      aiQueryButton: 'Chiedi al documento',
      aiResultTitle: 'Risultato AI',
      classicAiQuestionTitle: 'Chiedi all\'AI su questo documento',
      classicAiQuestionLabel: 'La tua domanda',
      ask: 'Chiedi',
      aiDisclaimer: 'I risultati generati dall\'intelligenza artificiale potrebbero essere imprecisi. Verificare sempre le informazioni critiche.',
      chatAiTitle: 'Ricerca AI',
      chatAiPlaceholder: 'Scrivi un messaggio (es: ho una audi a3 motore bag voglio sapere dove collegare il segnale giri motore)',
      chatAiSend: 'Invia',
      chatAiHelp: 'Descrivi il veicolo (marca, modello, codice motore se lo sai) e cosa ti serve: codici kit (order codes), calibrazioni (download calibrations), oppure istruzioni/manuale (manual info).',
      chatAiFollowUp: 'Informazioni mancanti:',
      chatAiOptionsModels: 'Modelli possibili:',
      chatAiNewChat: 'Nuova chat',
      chatAiManualDocDetails: 'Apri documento',
      chatAiVehicleLabel: 'Veicolo',
      chatAiIntentLabel: 'Intento',
      chatAiQuestionLabel: 'Domanda',
      // UI labels for option selection
      chatAiChoose: 'Scegli',
      chatAiSelect: 'Seleziona',
      // Mapping for next_action translation 
      chatAiNextActions: {
        brand: 'marca',
        model: 'modello',
        engine_code: 'codice motore',
        petrol_ecu: 'ECU benzina',
        intent: 'intento'
      },
      // intent specific labels
      chatIntent_download_calibration: 'download della calibrazione',
      chatIntent_download_manual: 'download del manuale',
      chatIntent_manual_info: 'ricerca nel manuale',
      chatIntent_order_codes: 'codici da ordinare',
      chatIntent_download_package: 'download del pacchetto',
      chatIntent_download_document: 'download del documento',
      chatIntent_view_documents: 'visualizza documenti',
      chatIntent_view_calibrations: 'visualizza calibrazioni',
      chatAiIntents: {
        download_calibration: 'Download della calibrazione',
        download_manual: 'Download del manuale',
        manual_info: 'Informazioni sul manuale',
        order_codes: 'Codici da ordinare',
      },
    },
    en: {
      title: `Feasibility - ${comBrand}`,
      marca: 'Brand',
      modello: 'Model',
      codiceMotore: 'Engine code',
      cerca: 'Search',
      chiedi: 'Ask',
      nessuno: 'None',
      selectBrandFirst: 'Select first a brand to get suggestions',
      selectBrandAndModelFirst: 'Select first a brand and a model to get suggestions',
      documents: 'Documents',
      packages: 'Packages and Calibrations',
      userNotes: 'User notes',
      headers: {
        cylinders: 'Cylinders',
        displacement: 'Displacement (cc)',
        power: 'Power (kW)',
        euro: 'Euro',
        petrolEcu: 'Petrol ECU'
      },
      classicSearchTitle: 'Classic Search',
      aiSearchTitle: 'AI Search',
      aiSearchLabel: 'Ask in natural language (e.g. "i have an alfa tonale, show electrical connections")',
      aiQueryButton: 'Ask Document',
      aiResultTitle: 'AI Result',
      classicAiQuestionTitle: 'Ask AI about this document',
      classicAiQuestionLabel: 'Your question',
      ask: 'Ask',
      aiDisclaimer: 'AI-generated results may be inaccurate. Always verify critical information.',
      chatAiTitle: 'AI Search',
      chatAiPlaceholder: 'Type a message (e.g.: i have an audi a3 engine bag i want to know where to connect rpm signal)',
      chatAiSend: 'Send',
      chatAiHelp: 'Describe the vehicle (brand, model, engine code if known) and what you need: kit codes (order codes), calibrations (download calibrations), or manual instructions (manual info).',
      chatAiFollowUp: 'Missing info:',
      chatAiOptionsModels: 'Possible models:',
      chatAiNewChat: 'New chat',
      chatAiManualDocDetails: 'Open document',
      chatAiVehicleLabel: 'Vehicle',
      chatAiIntentLabel: 'Intent',
      chatAiQuestionLabel: 'Question',
      // UI labels for option selection
      chatAiChoose: 'Choose',
      chatAiSelect: 'Select',
      // Mapping for next_action translation 
      chatAiNextActions: {
        brand: 'brand',
        model: 'model',
        engine_code: 'engine code',
        petrol_ecu: 'petrol ecu',
        intent: 'intent'
      },
      // intent specific labels
      chatIntent_download_calibration: 'download calibration',
      chatIntent_download_manual: 'download manual',
      chatIntent_manual_info: 'manual search',
      chatIntent_order_codes: 'order codes',
      chatIntent_download_package: 'download package',
      chatIntent_download_document: 'download document',
      chatIntent_view_documents: 'view documents',
      chatIntent_view_calibrations: 'view calibrations',
      chatAiIntents: {
        download_calibration: 'Download calibration',
        download_manual: 'Download manual',
        manual_info: 'Manual info',
        order_codes: 'Order codes',
      },
    }
  };
  return (base[lang] || base.it);
}
